export { default } from 'modules/specialist/specialistFree';
